import type { TMediaAnalysisOutcome } from './resolveMediaAnalysisOutcome';

export const NO_AUDIO_MESSAGE = 'No audio detected. This file has no audio track or is silent. Remove it to continue.';
export const ANALYSIS_TIMED_OUT_MESSAGE =
  "Analysis didn't finish within 5 minutes. Remove this file and upload it again. If it fails again, contact support.";
export const ANALYSIS_UNREACHABLE_MESSAGE =
  "We couldn't check this file's analysis because of a network error. Check your connection, then remove the file and upload it again.";

export const getMediaAnalysisExtra = (outcome: TMediaAnalysisOutcome): Record<string, unknown> | null => {
  switch (outcome.status) {
    case 'pending':
      return null;
    case 'done':
      return { duration: outcome.duration, analysisStatus: 'done' };
    case 'noAudio':
      return { duration: 0, analysisStatus: 'error', analysisErrorMessage: NO_AUDIO_MESSAGE };
    case 'failed':
      return { analysisStatus: 'error' };
    case 'timedOut':
      return { analysisStatus: 'error', analysisErrorMessage: ANALYSIS_TIMED_OUT_MESSAGE };
    case 'unreachable':
      return { analysisStatus: 'error', analysisErrorMessage: ANALYSIS_UNREACHABLE_MESSAGE };
  }
};
